import { createSlice } from "@reduxjs/toolkit";

export const mainSlice = createSlice({
    name: 'main',
    initialState: {
        lang: "tm",
        content: null,
        menu: false,
        sections: []
    },
    reducers: {
        setLang: (state, action) => {
            state.lang = action.payload;
        },
        setContent: (state, action) => {
            state.content = action.payload;
        },
        setMenu: (state) => {
            state.menu = !state.menu;
        },
        closeMenu: (state) => {
            state.menu = false;
        },
        setSections: (state, action) => {
            state.sections = action.payload;
        },
    },
});

export const { setLang, setContent, setMenu, closeMenu, setSections } = mainSlice.actions;

export default mainSlice.reducer